import '@hotwired/turbo-rails'
import 'promise-polyfill/src/polyfill'
import 'unfetch/polyfill'
import 'core-js'
import 'regenerator-runtime/runtime'
import RelayRuntime from 'relay-runtime'
import ReactRelay from 'react-relay'
import createReactClass from 'create-react-class'
import {Idiomorph} from 'idiomorph' // eslint-disable-line import/no-extraneous-dependencies

import setupGF from '../legacy/GlassFrog/setup'

import {enableWYSIWYG, disableWYSIWYG} from '../utils/MiscUtils/wysiwygFeatureFlag'
import getCurrentLocale from '../utils/getCurrentLocale'

import Glassfrog from '../Glassfrog'
import historySync from '../hotwire/historySync'
import setupReactIslandGuard from '../hotwire/setupReactIslandGuard'
import '../legacy_support/index'
import '../styles/glassfrog.scss'

// Drive ON: Turbo owns document navigation and browser history. React Router
// owns history only while OrgNavApp is mounted; historySync covers the
// entries it leaves behind.
Turbo.session.drive = true

// Expose Turbo globally for debugging and frame morphing
window.Turbo = Turbo

historySync.setupHistorySync()
setupReactIslandGuard()

setupGF()

window.Glassfrog = Glassfrog
// expose these for learning purposes
window.RelayRuntime = RelayRuntime
window.ReactRelay = ReactRelay
window.createReactClass = createReactClass
window.Idiomorph = Idiomorph

window.enableWYSIWYG = enableWYSIWYG
window.disableWYSIWYG = disableWYSIWYG

I18n.t = Glassfrog.utils.translateWithMissedKeysDetection(I18n.t)
I18n.locale = getCurrentLocale()
